import _axios from "../api";

export const getDocumentTemplateList = () => {
  return _axios.get(`/template/list`).then((response) => response.data);
};

export const isActiveDocumentTemplate = async (documentTemplateId, isActive) => {
  const response = await _axios.put(`/template/active-inactive/${documentTemplateId}/${isActive}`);

  return response.data;
};

export const getDocumentTemplateById = async (id) =>
  await _axios.get(`/template/${id}`).then((response) => {
    return response.data.data;
  });

export const getTemplateKeyById = async (id) =>
  await _axios.get(`/templatelist/${id}`).then((response) => {
    return response.data.data;
  });

export const deleteTemplate = async (id) =>
  await _axios.delete(`/template/delete/${id}`).then((response) => {
    return response.data;
  });

export const getTemplateTokenList = (id) => {
  return _axios.get(`/template/token/${id}`).then((response) => response.data.data);
};

export const getAuthorityTemplateList = () => {
  return _axios.get(`/authoritylist`).then((response) => response.data.data);
};

export const getTemplateHistoryList = async (id) =>
  await _axios.get(`/template/history-list/${id}`).then((response) => {
    return response.data.data;
  });

export const downLoadTemplate = async (id) =>
  await _axios.get(`/template/history-download/${id}`, {
    responseType: "blob"
  });

export const saveTemplate = async (TemplateModel) => {
  return await _axios
    .post(`/template/add`, JSON.stringify(TemplateModel))
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const updateTemplate = async (TemplateModel) => {
  return await _axios
    .put(`/template/update`, JSON.stringify(TemplateModel))
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const saveDraftTemplate = async (TemplateModel) => {
  return await _axios
    .post(`/template/savedraft`, JSON.stringify(TemplateModel))
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getDocumentTemplatedownById = async (TemplateModel) =>
  await _axios.post("/template/dowload-casetemplate", TemplateModel, {
    responseType: "blob"
  });

export const getDocumentTemplatedownByCaseId = async (caseManagerDetailId, documentTemplateId) =>
  await _axios
    .get(`/template/case/${caseManagerDetailId}/${documentTemplateId}`)
    .then((response) => {
      return response.data.data;
    });

export const CaseLogTemplate = async (id) =>
  await _axios.get(`/template/case-log/${id}`).then((response) => {
    return response.data.data;
  });

export const downLoadTemplateCaseId = async (id) =>
  await _axios.get(`/template/download-log/${id}`, {
    responseType: "blob"
  });
